const CRMType = `
  id
  description
  updatedAt
`;

export default CRMType;
